var _tspan, _tspan2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "205.365 50.748 259.767 59.478",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 205.365173, 46.154152)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M333.26,27.3l5.053,24.782,11.618,3.947-9.545-25.015L333.26,27.3",
    transform: "translate(-168.016 -4.556)",
    style: {
      fill: "rgb(0, 104, 55)",
      opacity: 0.18
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M292.31,49.395,298.27,27.3h0l6.991,4.249h0L304.23,55.627l-11.92-6.233",
    transform: "translate(-147.37 -4.556)",
    style: {
      fill: "rgb(0, 104, 55)",
      opacity: 0.19
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M280.3,31.811l-9.5,22.958,10.864-5.509L270.8,54.769l10-24.019,6.823-3.58,6.991,4.244,7.155-4.18,7.125,3.714,9.545,25.015-11.618-3.947L293.584,55.5l-11.92-6.238,11.92,6.238,13.239-3.481",
    transform: "translate(-136.526 -4.49)",
    style: {
      fill: "none",
      stroke: "rgb(0, 104, 55)",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(0 51)",
    style: {
      whiteSpace: "pre",
      fill: "rgb(0, 104, 55)",
      fontFamily: "Roboto-Medium, Roboto",
      fontSize: 49,
      fontWeight: 500,
      lineHeight: "78.4px",
      perspectiveOrigin: "55.6094px 0px"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "better"))), /*#__PURE__*/React.createElement("text", {
    className: "f",
    transform: "translate(181.548 51.54)",
    style: {
      whiteSpace: "pre",
      fill: "rgb(0, 104, 55)",
      fontFamily: "Roboto-Light, Roboto",
      fontSize: 49,
      fontWeight: 300,
      lineHeight: "78.4px",
      perspectiveOrigin: "32.6562px 0px"
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "aps")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a545e84b.svg";
export { ForwardRef as ReactComponent };